<template>
    <g>
        <component :is="label.getObjectType()+'_component'"
                   :label="label"
                   :imageData="imageData"
                   :selected="label.isSelected"
                   :hovered="label.isHovered"
                   @drag="$emit('drag')"
                   @undrag="$emit('undrag')"
                   @hover="label.enter()"
                   @unhover="label.leave()"
                   @unselect="label.unselect()"
                   @edit="$emit('edit')"
                   @select="$emit('select')"
        />
    </g>
</template>

<script>
    /*
    Composant qui regroupe l'intégralité des différents type de pointer pour les labels
    Chaque label à son propre composant pointer.
    Labels_Pointer est une interface pour simplifier l'intégration dans d'autre composant
    Il harmonise l'ensemble des données peu importe le type de label
     */

    import hotspot_component from "@/modules/labels/Hotspots_Pointer";
    import overlay_component from "@/modules/labels/Overlays_Pointer";
    import xrayspot_component from "@/modules/labels/XRays_Pointer";
    import text_component from "@/modules/labels/Texts_Pointer";
    import area_component from "@/modules/labels/Areas_Pointer";
    import marker_component from "@/modules/labels/Markers_Pointer";
    import boundingzoom_component from "@/modules/labels/BoundingZoom_Pointer";
    import {label} from "@/class/label";
    
    export default {
        name: "InteractiveImage_Labels_Pointer",
        components: {
            hotspot_component,overlay_component,xrayspot_component,text_component,area_component,marker_component,boundingzoom_component},
        props:{
            label:{type:Object,default:() => new label()},
            imageData:{type:Object},
        },
    }
</script>